import "./FeedChildFollow.css";

const FeedChildFollow = () => {
  return (
    <div id="feed_child_followContainer">
      <div id="feed_child_followContainerTitle">Who to follow</div>
      <div id="feed_child_followContainerUsers"></div>
    </div>
  );
};
export default FeedChildFollow;
